import { Box, Divider, Skeleton } from '@mui/material'
import { createArrayOfNumbers } from '../../../../../utils/helpers'

const CenterBellSkeleton = ({ size = 1 }) => (
  <Box sx={styles.notificationCardList}>
    <Skeleton variant="text" sx={styles.notificationTime} />
    {createArrayOfNumbers(size).map((item) => (
      <Box
        key={item}
        sx={styles.notificationCard}
      >
        <Box sx={styles.notificationInfo}>
          <Skeleton
            variant="rectangular"
            width={45}
            height={45}
            sx={styles.avatar}
          />
          <Box>
            <Box sx={styles.notificationHeader}>
              <Skeleton variant="text" sx={styles.notificationHeaderInfo} />
              <Skeleton variant="text" sx={styles.notificationHeaderInfo} />
            </Box>
            <Skeleton variant="text" sx={styles.notificationDescription} />
          </Box>
        </Box>
        <Divider sx={styles.divider} />
      </Box>
    ))}
  </Box>
)

const styles = {
  avatar: {
    borderRadius: { xs: '10px', sm: 'unset' },
  },
  notificationInfo: {
    display: 'flex',
    gap: '10px',
  },
  notificationCard: {
    gap: '10px',
    padding: '10px 0',
  },
  notificationHeader: {
    display: 'flex',
    gap: '20px',
  },
  notificationTime: {
    width: '60px',
    height: '24px',
  },
  notificationHeaderInfo: {
    width: { xs: '60px', sm: '100px' },
    height: '24px',
  },
  notificationDescription: {
    width: { xs: '180px', sm: '250px' },
    height: '24px',
  },
  divider: {
    width: { xs: '75%', sm: '70%' },
    margin: { xs: '10px 0px 0px 40px', sm: '10px 0px 0px 75px' },
  },
  notificationCardList: {
    maxHeight: { xs: '400px', sm: '390px' },
    overflowY: 'scroll',
    '::-webkit-scrollbar': {
      width: '0.3em',
    },
    '::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'primary.main',
    },
  },
}
export default CenterBellSkeleton
